export default __webpack_public_path__ + "static/media/gradient.af055b5e.png";